import CustomButton from '@/common/CustomButton';
import CustomModal from '@/common/CustomModal';
import FormItem from '@/common/FormItem';
import { editPlant } from '@/pages/settings/redux/slice';
//  createCategory
import { Col, Form, Input, Row, Skeleton, Switch, message } from 'antd';
import styles from './index.module.less';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
//import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

const EditModal = ({
  byIdLoading,
  setId,
  id,
  plant_id,
  onCancel,
  isEditModalVisible,
  setIsEditModalOpen,
  handleGetPlants
}) => {
  const dispatch = useDispatch();
  const [isActive, setIsActive] = useState(plant_id?.[0]?.is_active);
  // const [checked, setChecked] = useState(false);

  // const handleChange = (checked) => {
  //   setChecked(checked);
  // };
  const [form] = Form.useForm();
  // console.log('plant_id', plant_id?.[0]?.id);
  useEffect(() => {
    setId(plant_id?.[0]?.id);
    setIsActive(plant_id?.[0]?.is_active);
    /*  setAppId(flowData.app_id); */
    form.setFieldsValue({
      // is_active: plant_id?.[0]?.is_active,
      action: plant_id?.[0]?.is_active,
      name: plant_id?.[0]?.name
    });
  }, [plant_id, form]);

  const onFinish = (values) => {
    values['id'] = id;
    values['action'] = isActive ? 'activate' : 'deactivate';
    dispatch(editPlant(values)).then((response) => {
      if (response.payload.success) {
        message.success(response.payload.message);
        setIsEditModalOpen(false);
        handleGetPlants();
      } else {
        message.error(response.payload.message);
      }
    });
  };
  const handleSwitchChange = (checked) => {
    setIsActive(checked);
  };
  return (
    <CustomModal
      footer={
        <Form
          onFinish={onFinish}
          form={form}
          layout="vertical"
          className="ant-form ant-form-vertical"
        >
          <Row>
            <Col className="text-left" span={12}>
              <CustomButton onClick={onCancel}>Cancel</CustomButton>{' '}
            </Col>
            <Col className="text-right" span={12}>
              <CustomButton type="primary" htmlType="submit">
                Edit
              </CustomButton>
            </Col>
          </Row>
        </Form>
      }
      onCancel={onCancel}
      visible={isEditModalVisible}
      title="Edit Plant Details"
    >
      {byIdLoading ? (
        <Skeleton />
      ) : (
        <Form
          onFinish={onFinish}
          form={form}
          layout="vertical"
          className="ant-form ant-form-vertical"
        >
          <Row>
            <Col span={24}>
              <FormItem
                label={'Plant Name'}
                name="name"
                // className={`${styles.astrick}`}
                rules={[
                  {
                    required: true,
                    message: 'Please enter name'
                  }
                ]}
              >
                <Input placeholder="Enter Plant Name" />
              </FormItem>
            </Col>
            <Col span={24}>
              <FormItem
                label={'Status'}
                name="action"
                // className={`${styles.astrick}`}
                rules={[
                  {
                    required: true,
                    message: 'Please enter'
                  }
                ]}
              >
                <div
                  className={
                    isActive
                      ? `${styles.switcher_container}`
                      : `${styles.switcher_container1}`
                  }
                >
                  <Switch checked={isActive} onChange={handleSwitchChange} />
                </div>
              </FormItem>
            </Col>
          </Row>
        </Form>
      )}
    </CustomModal>
  );
};

export default EditModal;
